import MSidebar from './MSidebar.vue';

MSidebar.install = (app) => {
  app.component('MSidebar', MSidebar);
};

export { MSidebar };
